/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { EstadoReserva } from '../model/estadoReserva';
import { KoguiReservaPatch } from '../model/koguiReservaPatch';
import { KoguiReservasQueryType } from '../model/koguiReservasQueryType';
import { Movimiento } from '../model/movimiento';
import { Reserva } from '../model/reserva';
import { ReservaBase } from '../model/reservaBase';
import { TipoReserva } from '../model/tipoReserva';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class KoguiReservasService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Obtiene las reservas de un usuario.
     * Las reservas de un usuario.
     * @param usuario El usuario de kogui.
     * @param xFcmtoken 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $type 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioReservas(usuario: string, xFcmtoken?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $type?: KoguiReservasQueryType, observe?: 'body', reportProgress?: boolean): Observable<Array<Reserva>>;
    public getKoguiByUsuarioReservas(usuario: string, xFcmtoken?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $type?: KoguiReservasQueryType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Reserva>>>;
    public getKoguiByUsuarioReservas(usuario: string, xFcmtoken?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $type?: KoguiReservasQueryType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Reserva>>>;
    public getKoguiByUsuarioReservas(usuario: string, xFcmtoken?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $type?: KoguiReservasQueryType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($type !== undefined && $type !== null) {
            queryParameters = queryParameters.set('$type', <any>$type);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Reserva>>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la reservas de un usuario.
     * La reservas de un usuario.
     * @param usuario El usuario de kogui.
     * @param reservaId El id de una reserva asociado al usuario.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public getKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public getKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public getKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioReservasById.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getKoguiByUsuarioReservasById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Reserva>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/${encodeURIComponent(String(reservaId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista los movimientos de una reserva
     * Los movimientos de una reserva
     * @param usuario El usuario de kogui.
     * @param reservaId El id de una reserva asociado al usuario.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioReservasByIdMovimientos(usuario: string, reservaId: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Movimiento>>;
    public getKoguiByUsuarioReservasByIdMovimientos(usuario: string, reservaId: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Movimiento>>>;
    public getKoguiByUsuarioReservasByIdMovimientos(usuario: string, reservaId: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Movimiento>>>;
    public getKoguiByUsuarioReservasByIdMovimientos(usuario: string, reservaId: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioReservasByIdMovimientos.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getKoguiByUsuarioReservasByIdMovimientos.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Movimiento>>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/${encodeURIComponent(String(reservaId))}/movimientos/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica si el usuario tiene una reserva PRE, asociada a ese usuario.
     * Verifica reserva PRE, para una entidad
     * @param usuario El usuario de kogui.
     * @param type El tipo de entidad que se puede reservar
     * @param targetRef El id del evento o de la actividad.
     * @param xFcmtoken 
     * @param programacion La fecha de la programacion en el caso que sea una actividad.
     * @param estado El estado de la reserva que se quiere verififcar
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public headKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, xFcmtoken?: string, programacion?: string, estado?: EstadoReserva, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public headKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, xFcmtoken?: string, programacion?: string, estado?: EstadoReserva, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public headKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, xFcmtoken?: string, programacion?: string, estado?: EstadoReserva, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public headKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, xFcmtoken?: string, programacion?: string, estado?: EstadoReserva, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling headKoguiUsuariosByIdReservas.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling headKoguiUsuariosByIdReservas.');
        }
        if (targetRef === null || targetRef === undefined) {
            throw new Error('Required parameter targetRef was null or undefined when calling headKoguiUsuariosByIdReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }
        if (targetRef !== undefined && targetRef !== null) {
            queryParameters = queryParameters.set('target-ref', <any>targetRef);
        }
        if (programacion !== undefined && programacion !== null) {
            queryParameters = queryParameters.set('programacion', <any>programacion);
        }
        if (estado !== undefined && estado !== null) {
            queryParameters = queryParameters.set('estado', <any>estado);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.head<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param usuario El usuario de kogui.
     * @param reservaId El id de una reserva asociado al usuario.
     * @param xFcmtoken 
     * @param findReserva Indique que se devuelva la reserva modificada.
     * @param koguiReservaPatch Solicitud de Patch sobre la reserva.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, findReserva?: string, koguiReservaPatch?: KoguiReservaPatch, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public patchKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, findReserva?: string, koguiReservaPatch?: KoguiReservaPatch, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public patchKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, findReserva?: string, koguiReservaPatch?: KoguiReservaPatch, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public patchKoguiByUsuarioReservasById(usuario: string, reservaId: string, xFcmtoken?: string, findReserva?: string, koguiReservaPatch?: KoguiReservaPatch, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling patchKoguiByUsuarioReservasById.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling patchKoguiByUsuarioReservasById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (findReserva !== undefined && findReserva !== null) {
            queryParameters = queryParameters.set('find-reserva', <any>findReserva);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<Reserva>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/${encodeURIComponent(String(reservaId))}`,
            koguiReservaPatch,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Agrega un nuevo movimiento a la lista de movimientos
     * Agrega un nuevo movimiento a la lista de movimientos con el estado OK
     * @param usuario El usuario de kogui.
     * @param reservaId El id de una reserva asociado al usuario.
     * @param monto Monto del movimiento registrado.
     * @param fecha Fecha del movimiento registrado.
     * @param notas Nota o comentario sobre el movimiento.
     * @param xFcmtoken 
     * @param adjunto Adjunto con informacion o comporbante de pago
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postKoguiByUsuarioReservasByIdMovimientos(usuario: string, reservaId: string, monto: number, fecha: Date, notas: string, xFcmtoken?: string, adjunto?: Blob, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postKoguiByUsuarioReservasByIdMovimientos(usuario: string, reservaId: string, monto: number, fecha: Date, notas: string, xFcmtoken?: string, adjunto?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postKoguiByUsuarioReservasByIdMovimientos(usuario: string, reservaId: string, monto: number, fecha: Date, notas: string, xFcmtoken?: string, adjunto?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postKoguiByUsuarioReservasByIdMovimientos(usuario: string, reservaId: string, monto: number, fecha: Date, notas: string, xFcmtoken?: string, adjunto?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling postKoguiByUsuarioReservasByIdMovimientos.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling postKoguiByUsuarioReservasByIdMovimientos.');
        }
        if (monto === null || monto === undefined) {
            throw new Error('Required parameter monto was null or undefined when calling postKoguiByUsuarioReservasByIdMovimientos.');
        }
        if (fecha === null || fecha === undefined) {
            throw new Error('Required parameter fecha was null or undefined when calling postKoguiByUsuarioReservasByIdMovimientos.');
        }
        if (notas === null || notas === undefined) {
            throw new Error('Required parameter notas was null or undefined when calling postKoguiByUsuarioReservasByIdMovimientos.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (monto !== undefined) {
            formParams = formParams.append('monto', <any>monto) as any || formParams;
        }
        if (fecha !== undefined) {
            formParams = formParams.append('fecha', <any>fecha) as any || formParams;
        }
        if (notas !== undefined) {
            formParams = formParams.append('notas', <any>notas) as any || formParams;
        }
        if (adjunto !== undefined) {
            formParams = formParams.append('adjunto', <any>adjunto) as any || formParams;
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/${encodeURIComponent(String(reservaId))}/movimientos/`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una nueva reserva asociado a la actividad o al evento.
     * Aparte el cupo reservando par la actividad o evento.
     * @param usuario El usuario de kogui.
     * @param type El tipo de entidad que se puede reservar
     * @param targetRef El id del evento o de la actividad.
     * @param reservaBase Reserva Request
     * @param xFcmtoken 
     * @param programacion La fecha de la programacion en el caso que sea una actividad.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, reservaBase: ReservaBase, xFcmtoken?: string, programacion?: string, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public postKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, reservaBase: ReservaBase, xFcmtoken?: string, programacion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public postKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, reservaBase: ReservaBase, xFcmtoken?: string, programacion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public postKoguiUsuariosByIdReservas(usuario: string, type: TipoReserva, targetRef: string, reservaBase: ReservaBase, xFcmtoken?: string, programacion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling postKoguiUsuariosByIdReservas.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling postKoguiUsuariosByIdReservas.');
        }
        if (targetRef === null || targetRef === undefined) {
            throw new Error('Required parameter targetRef was null or undefined when calling postKoguiUsuariosByIdReservas.');
        }
        if (reservaBase === null || reservaBase === undefined) {
            throw new Error('Required parameter reservaBase was null or undefined when calling postKoguiUsuariosByIdReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }
        if (targetRef !== undefined && targetRef !== null) {
            queryParameters = queryParameters.set('target-ref', <any>targetRef);
        }
        if (programacion !== undefined && programacion !== null) {
            queryParameters = queryParameters.set('programacion', <any>programacion);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Reserva>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/`,
            reservaBase,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica si el usuario tiene una reserva PRE, asociada a ese usuario.
     * Verifica reserva PRE, para una entidad-
     * @param usuario El usuario de kogui.
     * @param type El tipo de entidad que se puede reservar
     * @param targetId El id de una entidad del cual se esta reservando.
     * @param xFcmtoken 
     * @param programacion La fecha de la programacion.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postReservaExistsForTypeAndRefId(usuario: string, type: TipoReserva, targetId: string, xFcmtoken?: string, programacion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postReservaExistsForTypeAndRefId(usuario: string, type: TipoReserva, targetId: string, xFcmtoken?: string, programacion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postReservaExistsForTypeAndRefId(usuario: string, type: TipoReserva, targetId: string, xFcmtoken?: string, programacion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postReservaExistsForTypeAndRefId(usuario: string, type: TipoReserva, targetId: string, xFcmtoken?: string, programacion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling postReservaExistsForTypeAndRefId.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling postReservaExistsForTypeAndRefId.');
        }
        if (targetId === null || targetId === undefined) {
            throw new Error('Required parameter targetId was null or undefined when calling postReservaExistsForTypeAndRefId.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (programacion !== undefined && programacion !== null) {
            queryParameters = queryParameters.set('programacion', <any>programacion);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.post<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/exists/${encodeURIComponent(String(type))}/${encodeURIComponent(String(targetId))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
